import UserProfileCard from "../../auth/components/UserProfileCard";
import { SandboxDisclaimer } from '../../../components/ui/disclaimers/SandBox'

interface PageHeaderProps {
    name: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ name }) => {
    return (
        <header className="sticky top-0 z-50 backdrop-blur-2xl bg-white/30 w-full border-t">
            <div className="flex items-center h-20 justify-between px-6 py-4 border-b">
                <h1 className="text-xl font-semibold text-neutral-900">{name}</h1>
                {/* <UserProfileCard /> */}
            </div>
            
            {/* <SandboxDisclaimer className="mx-6 mt-4" /> */}
            
        </header>
    );
};

export default PageHeader;
